// const LEGACY_MODEL_FAMILIES = ['q5-new', 'sq5-new', 'a5-new', 's5-new'];

export const cleanModelFamilies = (modelFamilies: string[] | undefined | null) => {
  if (!modelFamilies?.length) return [];
  const mappedArray = modelFamilies.map((item) => {
    const lowerCaseItem = item.toLowerCase();
    if (lowerCaseItem === 'q5-new') return 'q5';
    if (lowerCaseItem === 'sq5-new') return 'sq5';
    if (lowerCaseItem === 'a5-new') return 'a5';
    if (lowerCaseItem === 's5-new') return 's5';
    return item;
  });
  // Remove duplicates => for example if there is two q5 we need to remove one of them
  const uniqueArr = Array.from(new Set(mappedArray.map((item) => item.toLowerCase())));
  return uniqueArr;
};
